import {
    JoggCart,
    type JoggOrder,
    JoggOrderEnrich,
    type JoggOrderPaymentInfo,
    JoggWishlist,
    PdpProduct,
    SimpleWishlist,
} from "@jog/types"

import { AWSClient } from "./index"

const CHANNEL = process.env.NEXT_PUBLIC_WEBSHOP!
const LANGUAGE = process.env.NEXT_PUBLIC_LOCALE!
const STORE = process.env.NEXT_PUBLIC_STORE_ID!
export const commerceClient = () => AWSClient(process.env.NEXT_PUBLIC_AWS_COMMERCE_ENDPOINT || "")

export const getWishlist = (wishlistId: string) =>
    commerceClient()<JoggWishlist>({
        method: "GET",
        uri: `/wishlist/${wishlistId}?channel=${CHANNEL}&language=${LANGUAGE}`,
    })

export const addToWishlist = (id: string, productId: string) =>
    commerceClient()<SimpleWishlist>({
        method: "POST",
        uri: `/wishlist`,
        body: { channel: CHANNEL, language: LANGUAGE, id, productId },
    })

export const getSimpleWishlist = (wishlistId: string) =>
    commerceClient()<SimpleWishlist>({
        method: "GET",
        uri: `/wishlist/simple/${wishlistId}?channel=${CHANNEL}&language=${LANGUAGE}`,
    })

export const mergeWishlist = (id: string) =>
    commerceClient()<SimpleWishlist>({
        method: "POST",
        uri: "/wishlist/merge",
        body: { channel: CHANNEL, language: LANGUAGE, id },
    })
export const myWishlist = () =>
    commerceClient()<SimpleWishlist>({
        method: "GET",
        uri: `/wishlist?channel=${CHANNEL}&language=${LANGUAGE}`,
    })

export const removeFromWishlist = (id: string, lineItemId: string) =>
    commerceClient()<SimpleWishlist>({
        method: "PUT",
        uri: `/wishlist/${id}`,
        body: { id, lineItemId },
    })

export const getCart = (id: string) =>
    commerceClient()<JoggCart>({
        method: "GET",
        uri: `/cart/${id}`,
    })
export const getCartByToken = (token: string) =>
    commerceClient()<JoggCart>({ method: "GET", uri: `/cart/recovery?token=${token}` })

export const getOrderPayment = (order: string) =>
    commerceClient()<JoggOrderPaymentInfo>({
        method: "GET",
        uri: `/order/${order}/payment`,
    }).then((res) => res.body)

export const getOrderView = (order: string) =>
    commerceClient()<JoggOrder>({
        method: "GET",
        uri: `/order/${order}`,
    }).then((res) => res.body)

export const lookupAddress = (postcode: string, houseNumber: string) =>
    commerceClient()<{ city: string; streetname: string }>({
        method: "GET",
        uri: `/address/lookup/${postcode}/${houseNumber}`,
    }).then((res) => res.body)

export const getPdp = (id: string) =>
    commerceClient()<PdpProduct>({
        method: "GET",
        uri: `/product/${process.env.NEXT_PUBLIC_WEBSHOP!}/${id}`,
    }).then((res) => res.body)

export const getVariants = async (skus: string[]) => {
    return commerceClient()<JoggOrderEnrich>({
        method: "GET",
        uri: `/products/skus?sku=${skus.join(",")}`,
    }).then((res) => res.body)
}

export const getStockByStoreIds = (sku: string, stores: string[]) =>
    commerceClient()<Record<string, number>>({
        method: "GET",
        uri: `/products/stock/${sku}/${stores.join(",")}`,
    }).then((res) => res.body)

export const addProductsToCart = (cartId: string, items: { sku: string; quantity: number }[]) =>
    commerceClient()<JoggCart>({
        method: "POST",
        uri: `/cart/${cartId}/lineItems`,
        body: {
            channel: CHANNEL,
            items,
        },
    }).then((res) => res.body)

export const createCart = () =>
    commerceClient()<JoggCart>({
        method: "POST",
        uri: `/cart`,
        body: { store: STORE, locale: LANGUAGE },
    }).then((res) => res.body)

export const updateLineItem = (cartId: string, lineItemId: string, quantity: number) =>
    commerceClient()<JoggCart>({
        method: "PUT",
        uri: `/cart/${cartId}/lineItems/${lineItemId}`,
        body: { quantity },
    }).then((res) => res.body)

export const squeezelyContact = (email: string) =>
    commerceClient()<{ customer: { newsletter: boolean; email: string } | null }>({
        method: "POST",
        uri: `/squeezely/contact`,
        body: { email, storeId: process.env.NEXT_PUBLIC_STORE_ID },
    }).then((res) => res.body)

export const squeezelySubscribe = (email: string) =>
    commerceClient()<{ newsletter: boolean; email: string }>({
        method: "POST",
        uri: `/squeezely/subscribe`,
        body: { email, storeId: process.env.NEXT_PUBLIC_STORE_ID },
    }).then((res) => res.body)
